module.exports = __webpack_public_path__ + "img/2c.5000f576.png";